export function getUserId() {
    const userInfo = JSON.parse(localStorage.getItem('user'))

    return userInfo.userId
}

export function getUserName() {
    // 防空：未登录/本地无 user 缓存时不能抛异常（原实现会对 null 取 .name 直接报错）
    const userStr = localStorage.getItem('user')
    if (!userStr) {
        return ''
    }
    try {
        const userInfo = JSON.parse(userStr)
        return (userInfo && userInfo.name) || ''
    } catch (e) {
        return ''
    }
}

export function getUserTel() {
    const userInfo = JSON.parse(localStorage.getItem('user'))

    return userInfo.tel
}